/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function brandVideosSlider() {
  var slider = document.querySelector('.brandVideos__slider');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    watchCSS: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.brandVideos__slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
